import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import AccountMenu  from '../../Modules/AccountMenu'

import Docentschap from '../../Modules/Kennis/Toevoegen/Docentschap';

class MemberDocentschapAdd extends Component {
  render() {
    return (
      <div className="route">
      <AccountMenu/>
        <div className="grey-bg">
            <h1 className="pageTitle">
                Een docentschap toevoegen
            </h1>
            <p>Op deze webpagina kunt u uw permanente educatie activiteiten invullen.</p>
            <p>Bij bekende opleidingen en cursussen kunt u selecteren uit het opleidingen- en cursussenbestand van het Constructeursregister. U krijgt dan direct het aantal kenniseenheden te zien. Definitieve toewijzing van de kenniseenheden vindt plaats na beoordeling door de toetsingscommissie. Klik hier voor de toelichting..</p>
            <hr/>
            <Row>
              <Col md={12}>
                <Docentschap />
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <p><i>Het aantal punten wordt na controle door het secretariaat en/of Toetsingscommissie vastgesteld.</i></p>
              </Col>
            </Row>
            {/* <Bijeenkomst /> */}
        </div>
      </div>
    );
  }  
}

export default MemberDocentschapAdd;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Toevoegen/DocentschapAdd.js